import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_VIEW_SIZE } from '@utils/constants';

const useMobileMediaQuery = (fallback?: boolean) => {
  const isMobileByMediaQuery = useMediaQuery({
    query: `(max-width: ${MOBILE_VIEW_SIZE})`,
  });
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) {
    return fallback ?? false;
  }

  return isMobileByMediaQuery;
};

export default useMobileMediaQuery;
